import { createStore, applyMiddleware, compose } from 'redux';
import { autoRehydrate } from 'redux-persist';
import thunk from 'redux-thunk';
import { syncHistoryWithStore } from 'react-router-redux';

/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import BookTools, { getLogger } from 'book-dev-tools';
/* eslint-enable import/no-unresolved, import/no-extraneous-dependencies */

import { middlewareHistory, routerHistory } from '../routes/routerHistoryConfig';
import pesistStoreMigration from '../offline/persistStoreMigration';
import rootReducer from '../reducers/rootReducer';


const createStoreWithMiddleware = compose(
  applyMiddleware(thunk),
  applyMiddleware(middlewareHistory),
  pesistStoreMigration,
  autoRehydrate(),
  getLogger,
  process.env.NODE_ENV === 'development' ? BookTools.instrument() : f => f,
)(createStore);

const store = createStoreWithMiddleware(rootReducer);
export default store;

export const syncHistory = syncHistoryWithStore(routerHistory, store);

// Make reducers hot reloadable, see
// http://stackoverflow.com/questions/34243684/make-redux-reducers-and-other-non-components-hot-loadable
if (module.hot) {
  module.hot.accept('../reducers/rootReducer', () => {
    /* eslint global-require: 'off' */
    const nextRootReducer = require('../reducers/rootReducer').default;

    store.replaceReducer(nextRootReducer);
  });
}



// WEBPACK FOOTER //
// ./book/src/commons/store/store.js